<template>
  <b-modal
    id="examFilterModal"
    size="lg"
    title="Фильтр баллов ЕГЭ"
    @ok="onSave"
    @show="updateData"
  >
    <div class="d-flex flex-wrap" v-for="(mark, index) of localMarks" :key="index">
      <b-form-group :label="`Предмет ${index + 1}`" class="w-75 pr-2">
        <MultiSelect
          :value="mark.subject"
          :options="subjects"
          label="name"
          trackBy="id"
          @input="(data) => onSelectSubject(data, index)"
        />
      </b-form-group>
      <b-form-group label="Балл" class="w-25">
        <b-form-input
          required
          min="0"
          max="100"
          step="1"
          oninput="this.value = this.value > 100 ? 100 : this.value"
          type="number"
          v-model="mark.addMark"
        />
      </b-form-group>
    </div>
    <b-button @click="addEge" variant="primary" class="mb-2">
      Добавить
    </b-button>
    <b-alert variant="danger" :show="isIncorrectLength">
      Для фильтрации надо выбрать хотя бы 3 предмета
    </b-alert>
    <b-alert variant="danger" :show="isSameSubjects">
      Выбраны одинаковые предметы
    </b-alert>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isIncorrectLength || isSameSubjects">
        Сохранить
      </b-button>
      <b-button @click="dropFilters" variant="primary">
        Сбросить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'ExamFilterModal',
  components: {
    MultiSelect
  },
  props: {
    editData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  data() {
    return {
      localMarks: [],
      subjects: []
    }
  },
  computed: {
    isIncorrectLength() {
      const filled = this.localMarks.filter((subject) => subject.subject && subject.subject.length)
      return filled.length > 0 && filled.length < 3
    },
    isSameSubjects() {
      const filled = this.localMarks.filter((subject) => subject.subject && subject.subject.length)
      return _.uniqBy(filled, 'subject[0].id').length < filled.length
    }
  },
  async created() {
    const response = await RecommendationAPI.getExamSubjects()
    this.subjects = _.sortBy(response.data, 'name')
  },
  methods: {
    updateData() {
      this.localMarks = this.fillData(this.editData)
    },
    dropFilters() {
      this.localMarks = Array.from(Array(3)).map(() => ({
        subject: null,
        addMark: 0
      }))
    },
    onSave() {
      const subjects = this.localMarks.find((lm) => lm.subject && lm.subject.length)
        ? this.localMarks.map((lm) => ({
          subject: lm.subject ? lm.subject[0] : null,
          addMark: lm.addMark
        }))
        : []
      this.$emit('save', subjects)
    },
    fillData(data) {
      const localData = _.cloneDeep(data).map((ld) => ({ ...ld, subject: [ld.subject] }))
      while (localData.length < 3) {
        localData.push({
          subject: null,
          addMark: 0
        })
      }
      return localData
    },
    addEge() {
      this.localMarks.push({
        subject: null,
        addMark: 0
      })
    },
    onSelectSubject(data, index) {
      this.localMarks[index].subject = data ? [data] : null
    }
  }
}
</script>

<style scoped>

</style>
